var map = {
	"./1.webp": 2613,
	"./2.webp": 7336,
	"./3.webp": 2683,
	"./41.webp": 6661,
	"./51.webp": 3340,
	"./Carlos Alca.webp": 2995,
	"./clasico.webp": 5682,
	"./eredevise.webp": 5670,
	"./euro 2024 champs.webp": 9587,
	"./f1poster.webp": 4550,
	"./laliga.webp": 6190,
	"./liga endesa.webp": 4223,
	"./maroc 2025.webp": 7731,
	"./motogp.webp": 6044,
	"./nascarsports.webp": 905,
	"./nba.webp": 2541,
	"./olympic 2024 champs.webp": 6009,
	"./roger nadal.webp": 5463,
	"./ufc.webp": 6722
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6298;